/**
 * 单据管理- 商品表编辑
 * Author:  Fjj
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/10/09      1.0     First version
 *
 * Copyright 2016-2022, all rights reserved. Essa.cn
 * */

import React from 'react'
import FormFormat from '@components/FormFormat/FormFormat';
import {Button, Col, Descriptions, Input, message, Row,Checkbox } from 'antd';
import Lang from "@components/Lang/Lang";
import ShipperManagementAction from "../../../ShipperManagement.action";
import EssaModal from "@/components/EssaModal/EssaModal";
import ImageSlider from "@/components/ImageSlider/ImageSlider";
import CopyAndPaste from "@components/CopyAndPaste/CopyAndPaste";
import {toFixed2,isEmpty} from '@utils/utils';
import './Index.less'
const DescItem =Descriptions.Item;
const config = require("@config/config");
const { TextArea } = Input;
export default class GoodsListEdit extends React.Component{
    static defaultProps = {
        goodsOrderList:[]
    };
    constructor(props) {
        super(props);
        this.state = {
            list: props.goodsOrderList,
            // 编辑
            editRuOption:[
                {
                    name:'desc', //描述
                },
            ],
            showEditModal: false,
            // 已选 行
            checkNum:0
        }
    }
    /**
     * 保存
     * */
    async save(){
        const {orderInfo,saveApi, orderType} = this.props;
        this.props.loading(true)
        const res = await this.onRefFormFormat.handleOK();
        if(res.success){
            const { list } = this.state;
            // let postData = { ...orderInfo}//表单数据
            let postData = { ...res.data}//表单数据
            postData['containerId'] = this.props.containerId;
            if(orderType=='goods'){ //商品单 表格行数据
                postData['goodsOrderList'] = list;

            }else if(orderType=='goods_sub'){//样品商品单 表格行数据
                postData['goodsSubOrderItemList'] = list;
            }
            postData['version'] = orderInfo.version;
            if(saveApi)ShipperManagementAction.autoFetchAction(postData,saveApi).then(res=>this.handleSaveRes(res.data)).catch(err=>this.handleSaveRes(err))
        }
    }
    handleSaveRes(res){
        this.props.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id:'CaoZuoChengGong',default: "操作成功",}));
            this.props.edit(false)
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    /**
     * 品名
     * type '1': 俄文， '2': 英文
     * */
    editLang(type){
        const {checkNum} = this.state;
        if(checkNum>0){
            this.setState({
                showEditType:type,
                showEditModal:true,
                langSkuName:'',
            })
        }else message.warning(Lang({id: "QingXuanZeShangPin",default: "请选择商品"}));
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    /**
     * 行编
     *
     * */
    onChangeField(e,inx,field){
        const { target:{value}} = e;
        const {list,} = this.state;
        let newList = [...list];
        newList[inx][field] = value;
        this.setState({
            list:newList,
        })
        // if(!isHadEdit&&isEdit)this.setHadEdit(true);
    }
    /**
     * 选择
     * */
    onChangeItem(e,data={},inx){
        const { target:{checked}} = e;
        const {list} = this.state;
        let newList = [...list];
        newList[inx]["checked"] = checked;
        const selectList = newList.filter(item=>item.checked == true)||[]
        this.setState({
            list:newList,
            checkAll: list.length>0&&selectList.length==list.length,
            checkNum: selectList.length
        })
    }
    /**
     * 全选
     * */
    onCheckAllChange = e => {
        const flag = e.target.checked;
        const { list } = this.state;
        let newList = [...list];
        newList.forEach((item)=>item.checked = flag);
        this.setState({
            list:newList,
            checkAll: flag,
            checkNum:flag?newList.length:0
        });
    };
    /**
     * 渲染列表
     * **/
    renderOne(item={},inx){
        return(<div className={'itemLi'} key={item.id}>
            <div className={'pro flex-item-between'}>
                <Checkbox
                    checked={item.checked}
                    onChange={e=>this.onChangeItem(e,item,inx)}
                />
                <div className={"margin-left-5"}>
                    {item.isAdd==1&&item.skuPictureUrl?<img src={item.skuPictureUrl} className={'pro-img'} />:<ImageSlider list={item.pictureList} />}
                </div>
                {/*{item.skuPictureUrl?<img src={item.skuPictureUrl} />:<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}*/}
            </div>
            <div className={'info'}>
                <div className={'desc'}>
                    <Descriptions column={3} bordered>
                        <DescItem label={Lang({id: 'ShangPinBianMa', default: '商品编码'})}>{item.skuNo}</DescItem>
                        <DescItem label={Lang({id: 'LeiMu', default: '类目'})}>{item.categoryName}</DescItem>
                        <DescItem label={Lang({id: 'ZhuCaiZhi', default: '主材质'})}>{item.mainMaterials}</DescItem>
                        <DescItem label={Lang({id: 'HaiGuanBianMa', default: '海关编码'})}>{item.customsCode}</DescItem>
                        {/*<DescItem label={Lang({id: 'BaoZhuangNianLingBiaoQian', default: '包装年龄标签'})}>{skuInfo.mark}</DescItem>*/}
                        {/*<DescItem label={Lang({id: 'BaoZhuangLeiXing', default: '包装类型'})}>{skuInfo.packagingType}</DescItem>*/}
                        {this.renderAttribute(item.attributeList)}
                    </Descriptions>
                    {/* 自主新增只显示俄文品名,原系统 商品才显示 切换 */}
                    {item.isAdd==1?<Row className={'blackLink'}>
                        <Col span={4}>{Lang({id: 'ShangPinMingChen', default: '商品名称'})}</Col>
                        <Col span={20}>
                            {item.skuNameRu}
                        </Col>
                    </Row>:<Row className={'blackLink'}>
                        <Col span={4}>{Lang({id: 'ShangPinMingChen', default: '商品名称'})}</Col>
                        {item.showEnTitle==1?<Col span={20}>
                                <span className={'blackLink'}>
                                    {item.goodsId?<a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`}
                                                     target={'_blank'}>{item.skuNameEn}</a>:item.skuNameEn}
                                </span>
                            {item.skuNameRu&&<span className={'aLink'}
                                                   onClick={()=>this.onChangeField({target:{value:0}},inx,'showEnTitle')}>{Lang({id:'ChaKanEWenPinMing',default:'查看俄文品名'})}</span>}
                        </Col>:<Col span={20}>
                                <span className={'blackLink'}>
                                    {/*{item.skuNameRu}*/}
                                    {item.goodsId?<a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`}
                                                     target={'_blank'}>{item.skuNameRu}</a>:item.skuNameRu}
                                </span>
                            {item.skuNameEn&&<span className={'aLink'}
                                                   onClick={()=>this.onChangeField({target:{value:1}},inx,'showEnTitle')}>{Lang({id:'ChaKanYingWenPinMing',default:'查看英文品名'})}</span>}
                        </Col>}
                        </Row> }

                    {/* 原系统 商品才显示 贴纸品名 */}
                    {item.isAdd==0&&<Row className={'blackLink'}>
                        <Col span={4}>{Lang({id: 'TieZhiPinMing', default: '贴纸品名'})}</Col>
                        <Col span={20}>
                            {item.stickerNameRu}
                        </Col>
                    </Row>}

                </div>
                <div className={'option'}>
                    <Row className={'flex-item padding-top-10 padding-bottom-10'}>
                        <Col span={4}>{Lang({id: "ShangPinMiaoShu",default: "商品描述"})}</Col>
                        <Col span={20}>
                            <CopyAndPaste optionId={'Input_Copy_'+inx} pasteRes={(value)=>this.setGoodsDesc(value,inx)} />
                        </Col>
                    </Row>
                     {/* 商品描述 */}
                    <TextArea rows={11}
                              maxLength={512}
                              autoComplete={'off'}
                              placeholder={Lang({id: "QingShuRu",default: "请输入"})}
                              id={'Input_Copy_'+inx}
                              value={item.goodsDesc}
                              onChange={(value)=>this.changeGoodsDesc(value,inx)} />
                </div>
            </div>
        </div>)
    }
    /**
     * 行编海关编码
     * */
    changeGoodsDesc(e,inx){
        const { target:{value}} = e;
        // if(value.length<=10){
        this.setGoodsDesc(value,inx);
        // }
        return;
    }
    setGoodsDesc(value='',inx){
        const {list,isHadEdit} = this.state;
        let newList = [...list];
        newList[inx]['goodsDesc'] = value;
        newList[inx]['Input_Copy_'+inx] = value;
        this.setState({
            list:newList,
        })
        // if(!isHadEdit)this.setHadEdit(true);
    }
    /**
     * 渲染列表
     * **/
    renderAttribute(attributeList=[]){
        let childAtt = [];
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0)childAtt.push(<DescItem key={inx} label={att.attributeName}>{att.optionList.map((item, suinx)=>(<span key={suinx}>{item.optionName}</span>))}</DescItem>)
        })
        return childAtt;
    }
    onChangeLangSkuName(e){
        const { target:{value}} = e;
            this.setState({
                langSkuName:value
            })
    }
    /**
     * 批量更新数据
     * */
    updateData = async()=>{
        const { list,langSkuName } = this.state;
        if(isEmpty(langSkuName)){
            message.warning(Lang({id: "QingShuRu",default: "请输入"}));
            return
        }else {
            let newList = list;
            newList.forEach(item=>{
                if(item.checked) item['goodsDesc'] = langSkuName
            })
            this.setState({
                list:newList,
                showEditModal:false
            })
        }

    }
    flagShowEditModal(flag=false){
        this.setState({
            showEditModal:flag,
            langSkuName:'',
        })
    }

    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { editRuOption,selectList,showEditModal,langSkuName, checkAll,list,checkNum} = this.state;
        const { orderInfo } = this.props;
        return (<div className={"GoodsListEdit"}>
            {/* 表头 公司名称英文、中文、地址、注释*/}
            <div  className="padding-top-10 padding-bottom-10 bar">
                <div className={"text-center"}>
                    <p className={"font-20 padding-top-10 padding-bottom-10 color-black"}>{orderInfo.companyNameEn}</p>
                    <p>{orderInfo.companyNameZh}</p>
                </div>
                <div className="border-bottom padding-top-10 padding-bottom-10">
                    {orderInfo.companyAddress}
                </div>
                <div className="padding-top-10 padding-bottom-10">
                    <FormFormat onRef={this.onRefForm}
                                options={editRuOption}
                                formLayout = "vertical"
                                className={'form-format-white'}
                                initialValues={orderInfo} />
                </div>
            </div>
            {/* 表头 END */}
            {/* 列表 */}
            <div className={'itemList'}>
                {list.map((field,inx) =>{
                    field['Input_Copy_'+inx] = field.goodsDesc;
                    return this.renderOne(field, inx)
                })}
            </div>
            {/* 列表 END */}
            {/* 操作 START */}
            <div className={"footer flex-item-between"}>
                <div className={"padding-top-10"}>
                    <Checkbox
                        onChange={this.onCheckAllChange}
                        checked={checkAll}
                    />
                    <span className={'margin-left-5'}>{Lang({id: "YiXuanZeNKuan",default: `已选择{0}款`,params:[checkNum]})}</span>
                    <Button className={"margin-left-5"} onClick={()=>this.editLang('1')}>{Lang({id: "PiLiangBianJiMiaoShu",default: "批量编辑描述"})}</Button>
                </div>
                <div className={"padding-top-10 text-center"}>
                    <Button type="primary" onClick={()=>this.save()}>{Lang({id: "QueDing",default: "确定"})}</Button>
                    <Button className={"margin-left-5"} onClick={()=>this.props.edit(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                </div>
            </div>
            {/* 操作 END */}
            {showEditModal&&<EssaModal title={Lang({id: "PiLiangBianJiEWenMiaoShu",default: "批量编辑俄文描述"})}
                                       open={showEditModal}
                                       width={500}
                                       onOk={()=>this.updateData()}
                                       onCancel={()=>this.flagShowEditModal(false)}>
                <p className="padding-bottom-10"><span>{Lang({id: "YiXuanZeNKuan",default: `已选择{0}款`,params:[checkNum]})}</span></p>
                <TextArea rows={12} value={langSkuName}
                          placeholder={Lang({id: "QingShuRu",default: "请输入"})} onChange={(e)=>this.onChangeLangSkuName(e)}/>
            </EssaModal>}
        </div>)
    }
}
